/**
 * Feature flags — flip creatures and experimental systems on/off in one place.
 * Toggle live from the localhost debug menu, or change the defaults here.
 */
export const FEATURES = {
  familiar: true,   // the Arcane Wisp pet (orbiting glow + loot magnet)
  monsters: true,   // Quaternius "Ultimate Monsters" creature pack — mixed into every biome's spawn pool
  sharing: false,   // social share-card buttons (run + feats). Code stays; flip true to re-enable.
};
